import { render, staticRenderFns } from "./SupportSkeletonBox.vue?vue&type=template&id=3d6b2a16"
import script from "./SupportSkeletonBox.vue?vue&type=script&lang=js"
export * from "./SupportSkeletonBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports